var PreviewLogoComponent = (function () {
    function PreviewLogoComponent() {
        this.detail = {
            name_th: '',
            name_en: '',
            tax_id: '',
            address_th: '',
            address_en: '',
            post_code: ''
        };
    }
    return PreviewLogoComponent;
}());
export { PreviewLogoComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/preview-logo/preview-logo.component.ts.pre-build-optimizer.js